import { css } from 'styled-components';

export const svdTheme = css`
    --color-primary: #005D95;

    --color-state-primary: rgba(0, 93, 149, 0.07);
    --color-state-secondary: rgba(0, 93, 149, 0.24);
    --color-state-tertiary: rgba(48, 49, 48, 0.07);

    --color-outline: #0098DA;

    /* Home Page */
    --home-hero-background: linear-gradient(239deg, #0198DA 0%, #0B9EDE 100%);
    --home-hero-title-color: white;
    --home-hero-subtitle-color: white;

    /* Subscription Page */
    --subscription-hero-background: #FDEAE2;
    --subscription-hero-title-color: black;
    --subscription-hero-subtitle-color: black;

    /* User Shortcuts */
    --color-outline-accent: var(--color-primary);
`;
